/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "locale": "fr",
    "fields": {
      "year": {
        "displayName": "année",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} an",
            "other": "dans {0} ans"
          },
          "past": {
            "one": "il y a {0} an",
            "other": "il y a {0} ans"
          }
        }
      },
      "year-short": {
        "displayName": "an",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} a",
            "other": "dans {0} a"
          },
          "past": {
            "one": "il y a {0} a",
            "other": "il y a {0} a"
          }
        }
      },
      "year-narrow": {
        "displayName": "a",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} a",
            "other": "+{0} a"
          },
          "past": {
            "one": "-{0} a",
            "other": "-{0} a"
          }
        }
      },
      "quarter": {
        "displayName": "trimestre",
        "relative": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "-1": "le trimestre dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} trimestre",
            "other": "dans {0} trimestres"
          },
          "past": {
            "one": "il y a {0} trimestre",
            "other": "il y a {0} trimestres"
          }
        }
      },
      "quarter-short": {
        "displayName": "trim.",
        "relative": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "-1": "le trimestre dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} trim.",
            "other": "dans {0} trim."
          },
          "past": {
            "one": "il y a {0} trim.",
            "other": "il y a {0} trim."
          }
        }
      },
      "quarter-narrow": {
        "displayName": "trim.",
        "relative": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "-1": "le trimestre dernier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          }
        }
      },
      "month": {
        "displayName": "mois",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} mois",
            "other": "dans {0} mois"
          },
          "past": {
            "one": "il y a {0} mois",
            "other": "il y a {0} mois"
          }
        }
      },
      "month-short": {
        "displayName": "m.",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} m.",
            "other": "dans {0} m."
          },
          "past": {
            "one": "il y a {0} m.",
            "other": "il y a {0} m."
          }
        }
      },
      "month-narrow": {
        "displayName": "m.",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} m.",
            "other": "+{0} m."
          },
          "past": {
            "one": "-{0} m.",
            "other": "-{0} m."
          }
        }
      },
      "week": {
        "displayName": "semaine",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} semaine",
            "other": "dans {0} semaines"
          },
          "past": {
            "one": "il y a {0} semaine",
            "other": "il y a {0} semaines"
          }
        },
        "relativePeriod": "la semaine du {0}"
      },
      "week-short": {
        "displayName": "sem.",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} sem.",
            "other": "dans {0} sem."
          },
          "past": {
            "one": "il y a {0} sem.",
            "other": "il y a {0} sem."
          }
        },
        "relativePeriod": "sem. du {0}"
      },
      "week-narrow": {
        "displayName": "sem.",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          }
        },
        "relativePeriod": "sem. du {0}"
      },
      "day": {
        "displayName": "jour",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} jour",
            "other": "dans {0} jours"
          },
          "past": {
            "one": "il y a {0} jour",
            "other": "il y a {0} jours"
          }
        }
      },
      "day-short": {
        "displayName": "j",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} j",
            "other": "dans {0} j"
          },
          "past": {
            "one": "il y a {0} j",
            "other": "il y a {0} j"
          }
        }
      },
      "day-narrow": {
        "displayName": "j",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} j",
            "other": "+{0} j"
          },
          "past": {
            "one": "-{0} j",
            "other": "-{0} j"
          }
        }
      },
      "hour": {
        "displayName": "heure",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} heure",
            "other": "dans {0} heures"
          },
          "past": {
            "one": "il y a {0} heure",
            "other": "il y a {0} heures"
          }
        }
      },
      "hour-short": {
        "displayName": "h",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} h",
            "other": "dans {0} h"
          },
          "past": {
            "one": "il y a {0} h",
            "other": "il y a {0} h"
          }
        }
      },
      "hour-narrow": {
        "displayName": "h",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        }
      },
      "minute": {
        "displayName": "minute",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} minute",
            "other": "dans {0} minutes"
          },
          "past": {
            "one": "il y a {0} minute",
            "other": "il y a {0} minutes"
          }
        }
      },
      "minute-short": {
        "displayName": "min",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} min",
            "other": "dans {0} min"
          },
          "past": {
            "one": "il y a {0} min",
            "other": "il y a {0} min"
          }
        }
      },
      "minute-narrow": {
        "displayName": "min",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        }
      },
      "second": {
        "displayName": "seconde",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} seconde",
            "other": "dans {0} secondes"
          },
          "past": {
            "one": "il y a {0} seconde",
            "other": "il y a {0} secondes"
          }
        }
      },
      "second-short": {
        "displayName": "s",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} s",
            "other": "dans {0} s"
          },
          "past": {
            "one": "il y a {0} s",
            "other": "il y a {0} s"
          }
        }
      },
      "second-narrow": {
        "displayName": "s",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      }
    }
  }, {
    "locale": "fr-BE",
    "parentLocale": "fr"
  }, {
    "locale": "fr-BF",
    "parentLocale": "fr"
  }, {
    "locale": "fr-BI",
    "parentLocale": "fr"
  }, {
    "locale": "fr-BJ",
    "parentLocale": "fr"
  }, {
    "locale": "fr-BL",
    "parentLocale": "fr"
  }, {
    "locale": "fr-CA",
    "parentLocale": "fr",
    "fields": {
      "year": {
        "displayName": "année",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "Dans {0} an",
            "other": "Dans {0} ans"
          },
          "past": {
            "one": "Il y a {0} an",
            "other": "Il y a {0} ans"
          }
        }
      },
      "year-short": {
        "displayName": "a",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} a",
            "other": "dans {0} a"
          },
          "past": {
            "one": "il y a {0} a",
            "other": "il y a {0} a"
          }
        }
      },
      "year-narrow": {
        "displayName": "a",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} a",
            "other": "+{0} a"
          },
          "past": {
            "one": "-{0} a",
            "other": "-{0} a"
          }
        }
      },
      "quarter": {
        "displayName": "trimestre",
        "relative": {
          "0": "ce trimestre-ci",
          "1": "le trimestre prochain",
          "-1": "le trimestre dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} trimestre",
            "other": "dans {0} trimestres"
          },
          "past": {
            "one": "il y a {0} trimestre",
            "other": "il y a {0} trimestres"
          }
        }
      },
      "quarter-short": {
        "displayName": "trim.",
        "relative": {
          "0": "ce trimestre-ci",
          "1": "trim. prochain",
          "-1": "trim. dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} trim.",
            "other": "dans {0} trim."
          },
          "past": {
            "one": "il y a {0} trim.",
            "other": "il y a {0} trim."
          }
        }
      },
      "quarter-narrow": {
        "displayName": "trim.",
        "relative": {
          "0": "ce trimestre-ci",
          "1": "trim.prochain",
          "-1": "trim. dernier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          }
        }
      },
      "month": {
        "displayName": "mois",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} mois",
            "other": "dans {0} mois"
          },
          "past": {
            "one": "il y a {0} mois",
            "other": "il y a {0} mois"
          }
        }
      },
      "month-short": {
        "displayName": "m.",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} m.",
            "other": "dans {0} m."
          },
          "past": {
            "one": "il y a {0} m.",
            "other": "il y a {0} m."
          }
        }
      },
      "month-narrow": {
        "displayName": "m.",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} m.",
            "other": "+{0} m."
          },
          "past": {
            "one": "-{0} m.",
            "other": "-{0} m."
          }
        }
      },
      "week": {
        "displayName": "semaine",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} semaine",
            "other": "dans {0} semaines"
          },
          "past": {
            "one": "il y a {0} semaine",
            "other": "il y a {0} semaines"
          }
        },
        "relativePeriod": "la semaine du {0}"
      },
      "week-short": {
        "displayName": "sem.",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} sem.",
            "other": "dans {0} sem."
          },
          "past": {
            "one": "il y a {0} sem.",
            "other": "il y a {0} sem."
          }
        },
        "relativePeriod": "sem. du {0}"
      },
      "week-narrow": {
        "displayName": "sem.",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          }
        },
        "relativePeriod": "sem. du {0}"
      },
      "day": {
        "displayName": "jour",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} jour",
            "other": "dans {0} jours"
          },
          "past": {
            "one": "il y a {0} jour",
            "other": "il y a {0} jours"
          }
        }
      },
      "day-short": {
        "displayName": "j",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} j",
            "other": "dans {0} j"
          },
          "past": {
            "one": "il y a {0} j",
            "other": "il y a {0} j"
          }
        }
      },
      "day-narrow": {
        "displayName": "j",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} j",
            "other": "+{0} j"
          },
          "past": {
            "one": "-{0} j",
            "other": "-{0} j"
          }
        }
      },
      "hour": {
        "displayName": "heure",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} heure",
            "other": "dans {0} heures"
          },
          "past": {
            "one": "il y a {0} heure",
            "other": "il y a {0} heures"
          }
        }
      },
      "hour-short": {
        "displayName": "h",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} h",
            "other": "dans {0} h"
          },
          "past": {
            "one": "il y a {0} h",
            "other": "il y a {0} h"
          }
        }
      },
      "hour-narrow": {
        "displayName": "h",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        }
      },
      "minute": {
        "displayName": "minute",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} minute",
            "other": "dans {0} minutes"
          },
          "past": {
            "one": "il y a {0} minute",
            "other": "il y a {0} minutes"
          }
        }
      },
      "minute-short": {
        "displayName": "min",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} min",
            "other": "dans {0} min"
          },
          "past": {
            "one": "il y a {0} min",
            "other": "il y a {0} min"
          }
        }
      },
      "minute-narrow": {
        "displayName": "min",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        }
      },
      "second": {
        "displayName": "seconde",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} seconde",
            "other": "dans {0} secondes"
          },
          "past": {
            "one": "il y a {0} seconde",
            "other": "il y a {0} secondes"
          }
        }
      },
      "second-short": {
        "displayName": "s",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} s",
            "other": "dans {0} s"
          },
          "past": {
            "one": "il y a {0} s",
            "other": "il y a {0} s"
          }
        }
      },
      "second-narrow": {
        "displayName": "s",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "+ {0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      }
    }
  }, {
    "locale": "fr-CD",
    "parentLocale": "fr"
  }, {
    "locale": "fr-CF",
    "parentLocale": "fr"
  }, {
    "locale": "fr-CG",
    "parentLocale": "fr"
  }, {
    "locale": "fr-CH",
    "parentLocale": "fr"
  }, {
    "locale": "fr-CI",
    "parentLocale": "fr"
  }, {
    "locale": "fr-CM",
    "parentLocale": "fr"
  }, {
    "locale": "fr-DJ",
    "parentLocale": "fr"
  }, {
    "locale": "fr-DZ",
    "parentLocale": "fr"
  }, {
    "locale": "fr-GA",
    "parentLocale": "fr"
  }, {
    "locale": "fr-GF",
    "parentLocale": "fr"
  }, {
    "locale": "fr-GN",
    "parentLocale": "fr"
  }, {
    "locale": "fr-GP",
    "parentLocale": "fr"
  }, {
    "locale": "fr-GQ",
    "parentLocale": "fr"
  }, {
    "locale": "fr-HT",
    "parentLocale": "fr",
    "fields": {
      "year": {
        "displayName": "année",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} an",
            "other": "dans {0} ans"
          },
          "past": {
            "one": "il y a {0} an",
            "other": "il y a {0} ans"
          }
        }
      },
      "year-short": {
        "displayName": "an",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} a",
            "other": "dans {0} a"
          },
          "past": {
            "one": "il y a {0} a",
            "other": "il y a {0} a"
          }
        }
      },
      "year-narrow": {
        "displayName": "a",
        "relative": {
          "0": "cette année",
          "1": "l’année prochaine",
          "-1": "l’année dernière"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} a",
            "other": "+{0} a"
          },
          "past": {
            "one": "-{0} a",
            "other": "-{0} a"
          }
        }
      },
      "quarter": {
        "displayName": "trimestre",
        "relative": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "-1": "le trimestre dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} trimestre",
            "other": "dans {0} trimestres"
          },
          "past": {
            "one": "il y a {0} trimestre",
            "other": "il y a {0} trimestres"
          }
        }
      },
      "quarter-short": {
        "displayName": "trim.",
        "relative": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "-1": "le trimestre dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} trim.",
            "other": "dans {0} trim."
          },
          "past": {
            "one": "il y a {0} trim.",
            "other": "il y a {0} trim."
          }
        }
      },
      "quarter-narrow": {
        "displayName": "trim.",
        "relative": {
          "0": "ce trimestre",
          "1": "le trimestre prochain",
          "-1": "le trimestre dernier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} trim.",
            "other": "+{0} trim."
          },
          "past": {
            "one": "-{0} trim.",
            "other": "-{0} trim."
          }
        }
      },
      "month": {
        "displayName": "mois",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} mois",
            "other": "dans {0} mois"
          },
          "past": {
            "one": "il y a {0} mois",
            "other": "il y a {0} mois"
          }
        }
      },
      "month-short": {
        "displayName": "m.",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} m.",
            "other": "dans {0} m."
          },
          "past": {
            "one": "il y a {0} m.",
            "other": "il y a {0} m."
          }
        }
      },
      "month-narrow": {
        "displayName": "m.",
        "relative": {
          "0": "ce mois-ci",
          "1": "le mois prochain",
          "-1": "le mois dernier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} m.",
            "other": "+{0} m."
          },
          "past": {
            "one": "-{0} m.",
            "other": "-{0} m."
          }
        }
      },
      "week": {
        "displayName": "semaine",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} semaine",
            "other": "dans {0} semaines"
          },
          "past": {
            "one": "il y a {0} semaine",
            "other": "il y a {0} semaines"
          }
        },
        "relativePeriod": "la semaine du {0}"
      },
      "week-short": {
        "displayName": "sem.",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} sem.",
            "other": "dans {0} sem."
          },
          "past": {
            "one": "il y a {0} sem.",
            "other": "il y a {0} sem."
          }
        },
        "relativePeriod": "sem. du {0}"
      },
      "week-narrow": {
        "displayName": "sem.",
        "relative": {
          "0": "cette semaine",
          "1": "la semaine prochaine",
          "-1": "la semaine dernière"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} sem.",
            "other": "+{0} sem."
          },
          "past": {
            "one": "-{0} sem.",
            "other": "-{0} sem."
          }
        },
        "relativePeriod": "sem. du {0}"
      },
      "day": {
        "displayName": "jour",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} jour",
            "other": "dans {0} jours"
          },
          "past": {
            "one": "il y a {0} jour",
            "other": "il y a {0} jours"
          }
        }
      },
      "day-short": {
        "displayName": "jr.",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} j",
            "other": "dans {0} j"
          },
          "past": {
            "one": "il y a {0} j",
            "other": "il y a {0} j"
          }
        }
      },
      "day-narrow": {
        "displayName": "jr.",
        "relative": {
          "0": "aujourd’hui",
          "1": "demain",
          "2": "après-demain",
          "-2": "avant-hier",
          "-1": "hier"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} j",
            "other": "+{0} j"
          },
          "past": {
            "one": "-{0} j",
            "other": "-{0} j"
          }
        }
      },
      "hour": {
        "displayName": "heure",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} heure",
            "other": "dans {0} heures"
          },
          "past": {
            "one": "il y a {0} heure",
            "other": "il y a {0} heures"
          }
        }
      },
      "hour-short": {
        "displayName": "hr",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} h",
            "other": "dans {0} h"
          },
          "past": {
            "one": "il y a {0} h",
            "other": "il y a {0} h"
          }
        }
      },
      "hour-narrow": {
        "displayName": "hr",
        "relative": {
          "0": "cette heure-ci"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} h",
            "other": "+{0} h"
          },
          "past": {
            "one": "-{0} h",
            "other": "-{0} h"
          }
        }
      },
      "minute": {
        "displayName": "minute",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} minute",
            "other": "dans {0} minutes"
          },
          "past": {
            "one": "il y a {0} minute",
            "other": "il y a {0} minutes"
          }
        }
      },
      "minute-short": {
        "displayName": "min.",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} min",
            "other": "dans {0} min"
          },
          "past": {
            "one": "il y a {0} min",
            "other": "il y a {0} min"
          }
        }
      },
      "minute-narrow": {
        "displayName": "min.",
        "relative": {
          "0": "cette minute-ci"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} min",
            "other": "+{0} min"
          },
          "past": {
            "one": "-{0} min",
            "other": "-{0} min"
          }
        }
      },
      "second": {
        "displayName": "seconde",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} seconde",
            "other": "dans {0} secondes"
          },
          "past": {
            "one": "il y a {0} seconde",
            "other": "il y a {0} secondes"
          }
        }
      },
      "second-short": {
        "displayName": "s",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "dans {0} s",
            "other": "dans {0} s"
          },
          "past": {
            "one": "il y a {0} s",
            "other": "il y a {0} s"
          }
        }
      },
      "second-narrow": {
        "displayName": "sec.",
        "relative": {
          "0": "maintenant"
        },
        "relativeTime": {
          "future": {
            "one": "+{0} s",
            "other": "+{0} s"
          },
          "past": {
            "one": "-{0} s",
            "other": "-{0} s"
          }
        }
      }
    }
  }, {
    "locale": "fr-KM",
    "parentLocale": "fr"
  }, {
    "locale": "fr-LU",
    "parentLocale": "fr"
  }, {
    "locale": "fr-MA",
    "parentLocale": "fr"
  }, {
    "locale": "fr-MC",
    "parentLocale": "fr"
  }, {
    "locale": "fr-MF",
    "parentLocale": "fr"
  }, {
    "locale": "fr-MG",
    "parentLocale": "fr"
  }, {
    "locale": "fr-ML",
    "parentLocale": "fr"
  }, {
    "locale": "fr-MQ",
    "parentLocale": "fr"
  }, {
    "locale": "fr-MR",
    "parentLocale": "fr"
  }, {
    "locale": "fr-MU",
    "parentLocale": "fr"
  }, {
    "locale": "fr-NC",
    "parentLocale": "fr"
  }, {
    "locale": "fr-NE",
    "parentLocale": "fr"
  }, {
    "locale": "fr-PF",
    "parentLocale": "fr"
  }, {
    "locale": "fr-PM",
    "parentLocale": "fr"
  }, {
    "locale": "fr-RE",
    "parentLocale": "fr"
  }, {
    "locale": "fr-RW",
    "parentLocale": "fr"
  }, {
    "locale": "fr-SC",
    "parentLocale": "fr"
  }, {
    "locale": "fr-SN",
    "parentLocale": "fr"
  }, {
    "locale": "fr-SY",
    "parentLocale": "fr"
  }, {
    "locale": "fr-TD",
    "parentLocale": "fr"
  }, {
    "locale": "fr-TG",
    "parentLocale": "fr"
  }, {
    "locale": "fr-TN",
    "parentLocale": "fr"
  }, {
    "locale": "fr-VU",
    "parentLocale": "fr"
  }, {
    "locale": "fr-WF",
    "parentLocale": "fr"
  }, {
    "locale": "fr-YT",
    "parentLocale": "fr"
  });
}